import React from 'react';
import styled from 'styled-components';

interface ProductContentProps {
  htmlString: string;
}

const ProductContent: React.FC<ProductContentProps> = ({ htmlString }) => {
  console.log('HTML Content received:', htmlString);

  return (
    <Container>
      <ContentSection>
        <Content dangerouslySetInnerHTML={{ __html: htmlString || "<p>상품 설명이 없습니다.</p>" }} />
      </ContentSection>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  background-color: white;
  margin-bottom: 10px;
`;

const ContentSection = styled.div`
  margin: 0;
`;

const Content = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  margin: 0;
  word-break: break-word;
`;

export default ProductContent;